export default "__VITE_ASSET__RHeB3zP3__"